import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

function TooltipRoot({ children, className, ...rest }) {
  return (
    <div
      className={twMerge('parent relative flex w-fit items-center', className)}
      {...rest}
    >
      {children}
    </div>
  );
}

TooltipRoot.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default TooltipRoot;
